<template>
  <div>
    <template v-for="channel in channels">
      <v-btn
        :key="`channel_${channel.value}`"
        depressed
        :outline="value != channel.fullValue"
        :color="value == channel.fullValue ? 'primary' : 'grey'"
        class="ma-0 mr-1 mb-1"
        @click="onchange(channel.fullValueForUse)"
      >
        <em v-if="channel.icon" :class="`${channel.icon} mr-1`" />{{ $t(channel.text) }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import LivechatSocialChannel from '@/components/view/livechat/LivechatSocialChannelMixin'
export default {
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  mixins: [LivechatSocialChannel],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    channels() {
      const channels = this.handleGetChannelOptions(this.$store.getters.selectedBot)
      return [
        {
          value: 'all',
          fullValue: 'all',
          fullValueForUse: 'all',
          text: 'All',
          icon: ''
        },
        ...channels
      ]
    }
  },
  methods: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    onchange(value) {
      this.$emit('input', value)
      this.$emit('changeChannel', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DashboardSelectChannel.vue